import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_POPUPS_PENDING: state => ({
			...state,
			loading: {
				...state.loading,
				popups: true,
			},
		}),
		FETCH_POPUPS_FULFILLED: (state, action) => ({
			...state,
			popups: action.payload.popups,
			loading: {
				...state.loading,
				popups: false,
			},
		}),
		FETCH_POPUP_INDEX_PENDING: state => ({
			...state,
			loading: {
				...state.loading,
				popupIndex: true,
			},
		}),
		FETCH_POPUP_INDEX_FULFILLED: (state, action) => ({
			...state,
			popupIndex: action.payload.popupIndex,
			loading: {
				...state.loading,
				popupIndex: false,
			},
		}),
		CLOSE_POPUP: state => ({
			...state,
			active: false,
		}),
	},
	{
		active: true,
		popups: [],
		popupIndex: [],
		loading: {
			popups: false,
			popupIndex: false,
		},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/popup.js